import { DbRef } from "./firebase";
/**
 * The name of an unknown scheduling user used on draft waypoints.
 */
export const UNKNOWN_SCHEDULING_USER = 'Unknown scheduling user';
export var PatientFormStep;
(function (PatientFormStep) {
    PatientFormStep[PatientFormStep["SEARCH_PATIENTS"] = 0] = "SEARCH_PATIENTS";
    PatientFormStep[PatientFormStep["EDIT_PATIENT"] = 1] = "EDIT_PATIENT";
    PatientFormStep[PatientFormStep["CREATE_PATIENT"] = 2] = "CREATE_PATIENT";
})(PatientFormStep || (PatientFormStep = {}));
export var AuthStatus;
(function (AuthStatus) {
    /**
     * User is fully signed out
     */
    AuthStatus["SIGNED_OUT"] = "signedOut";
    /**
     * Firebase has been authenticated
     */
    AuthStatus["FIREBASE_AUTH"] = "firebaseAuth";
    /**
     * For all users:
     * - Firebase authed
     * - Encryption access ready
     *
     * For office staff (assistants, prescribers):
     * - Office bound
     */
    AuthStatus["COMPLETE"] = "complete";
})(AuthStatus || (AuthStatus = {}));
export var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["APPROVED"] = "approved";
    DocumentStatus["DECLINED"] = "declined";
    DocumentStatus["PENDING"] = "pending";
    DocumentStatus["CANCELED"] = "canceled";
    DocumentStatus["LOCKED"] = "locked";
})(DocumentStatus || (DocumentStatus = {}));
export var Gender;
(function (Gender) {
    Gender["MALE"] = "male";
    Gender["FEMALE"] = "female";
})(Gender || (Gender = {}));
export var InsurancePlanType;
(function (InsurancePlanType) {
    InsurancePlanType["HMO"] = "HMO";
    InsurancePlanType["PPO"] = "PPO";
})(InsurancePlanType || (InsurancePlanType = {}));
export var LanguageFluency;
(function (LanguageFluency) {
    LanguageFluency["NATIVE"] = "native";
    LanguageFluency["FLUENT"] = "fluent";
    LanguageFluency["CONVERSATIONAL"] = "conversational";
})(LanguageFluency || (LanguageFluency = {}));
export var Role;
(function (Role) {
    Role["ASSISTANT"] = "assistant";
    Role["NURSE"] = "nurse";
    Role["PACKER"] = "packer";
    Role["PATIENT"] = "patient";
    Role["PRESCRIBER"] = "prescriber";
    Role["SUPERADMIN"] = "superAdmin";
    Role["RECRUITER"] = "recruiter";
})(Role || (Role = {}));
export var PolicyHolderRelationship;
(function (PolicyHolderRelationship) {
    /**
     * 'OTHER', 'SPOUSE', and 'PARENT' describe the relationship between the
     * policy holder and the beneficiary.
     */
    PolicyHolderRelationship["OTHER"] = "other";
    PolicyHolderRelationship["SPOUSE"] = "spouse";
    PolicyHolderRelationship["PARENT"] = "parent";
    /**
     * 'SELF' will be used when creating coverages within Health Gorilla.
     * Not an option for the user to select.
     */
    PolicyHolderRelationship["SELF"] = "self";
})(PolicyHolderRelationship || (PolicyHolderRelationship = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["INCOMPLETE"] = "incomplete";
    UserStatus["WAITLISTED"] = "waitlisted";
    UserStatus["MISSING_INFORMATION"] = "missingInformation";
    UserStatus["REQUIRE_INTERVIEW"] = "requireInterview";
    UserStatus["INTERVIEW_SCHEDULED"] = "interviewScheduled";
    UserStatus["INTERVIEW_COMPLETE"] = "interviewComplete";
    UserStatus["REQUIRE_APPROVAL"] = "requireApproval";
    UserStatus["APPROVED"] = "approved";
    UserStatus["DECLINED"] = "declined";
    UserStatus["PENDING"] = "pending";
})(UserStatus || (UserStatus = {}));
export var UserShiftAvailabilityQuality;
(function (UserShiftAvailabilityQuality) {
    /** None - My schedule will remain the same */
    UserShiftAvailabilityQuality["REGULAR"] = "regular";
    /** Likely - It varies from week to week. */
    UserShiftAvailabilityQuality["VARIABLE"] = "variable";
    /** Unpredictable - My schedule is constantly changing. */
    UserShiftAvailabilityQuality["UNPREDICTABLE"] = "unpredictable";
})(UserShiftAvailabilityQuality || (UserShiftAvailabilityQuality = {}));
export var UserPlaceRole;
(function (UserPlaceRole) {
    UserPlaceRole["PATIENT"] = "patient";
    UserPlaceRole["PRIMARY_CONTACT"] = "primaryContact";
})(UserPlaceRole || (UserPlaceRole = {}));
export var UserOfficeRole;
(function (UserOfficeRole) {
    UserOfficeRole["STAFFING_MANAGER"] = "staffingManager";
})(UserOfficeRole || (UserOfficeRole = {}));
export const UserRelationshipKeys = {
    caresFor: { ref: DbRef.USERS },
    offices: { ref: DbRef.OFFICES },
    orders: { ref: DbRef.ORDERS },
    shifts: { ref: DbRef.SHIFTS },
    shiftOffers: { ref: DbRef.SHIFTS },
};
//# sourceMappingURL=user.js.map